import { ShoppingCartSimpleIcon, PackageIcon } from "@phosphor-icons/react";
import { handleCardCtaClick } from "../../MobileApp/webviewBridge";
import type { CheckoutCardData } from "./validate";
export type { CheckoutCardData } from "./validate";

export function formatTotal(amount: number): string {
  return Number.isInteger(amount) ? `$${amount}` : `$${amount.toFixed(2)}`;
}

interface CheckoutCardProps {
  data: CheckoutCardData;
}

export function CheckoutCard({ data }: CheckoutCardProps) {
  return (
    <div className="lk-checkout-card">
      {data.imageUrl && (
        <div
          className="lk-checkout-card-image"
          style={{ backgroundImage: `url(${data.imageUrl})` }}
          role="img"
          aria-label={data.productTitle}
        />
      )}
      <div className="lk-checkout-card-body">
        <div className="lk-checkout-card-top">
          <div className="lk-checkout-card-brand">{data.brand.toUpperCase()}</div>
          <div className="lk-checkout-card-name">{data.productTitle}</div>
          {data.variantTitle && data.variantTitle !== "Default Title" && (
            <div className="lk-checkout-card-variant">{data.variantTitle}</div>
          )}
        </div>
        <div className="lk-checkout-card-rows">
          <div className="lk-checkout-card-row">
            <PackageIcon size={16} weight="regular" className="lk-checkout-card-icon" />
            <span>Qty: {data.quantity}</span>
          </div>
          <div className="lk-checkout-card-row">
            <ShoppingCartSimpleIcon size={16} weight="regular" className="lk-checkout-card-icon" />
            <span>In stock</span>
          </div>
        </div>
        <div className="lk-checkout-card-price-row">
          <span className="lk-checkout-card-total-label">Total</span>
          <span className="lk-checkout-card-total">{formatTotal(data.totalAmount)}</span>
        </div>
        <a
          className="lk-checkout-card-cta"
          href={data.checkoutUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => handleCardCtaClick(e, data.checkoutUrl, "checkout")}
        >
          Checkout on {data.storeDomain ?? `${data.brand}.com`}
        </a>
      </div>
    </div>
  );
}
